/**
 * The Games page's addresses. All of them sit under `/a/games` and within the
 * three path segments the edge serves snapshots for (`/a/<seg>[/<seg>[/<seg>]]`),
 * so every page here can have a crawlable snapshot.
 */
import type { GameSort } from './types';

export const GAMES_HOME_PATH = '/a/games';

/** The most played games, ranked. */
export const GAMES_MOST_PLAYED_PATH = `${GAMES_HOME_PATH}/most-played`;

export function gamesGenrePath(genreId: string, sort?: GameSort): string {
  const path = `${GAMES_HOME_PATH}/genre/${encodeURIComponent(genreId)}`;
  return sort && sort !== 'popular' ? `${path}?sort=${sort}` : path;
}

export function gamePagePath(slug: string): string {
  return `${GAMES_HOME_PATH}/game/${encodeURIComponent(slug)}`;
}

/** Every game in one arche, by its key (`archeKey` on a card). */
export function gamesArchePath(archeKey: string): string {
  return `${GAMES_HOME_PATH}/from/${encodeURIComponent(archeKey)}`;
}

/** Search results live on the home page's address, as a real `GET ?q=`. */
export function gamesSearchPath(query: string): string {
  const q = query.trim();
  return q ? `${GAMES_HOME_PATH}?q=${encodeURIComponent(q)}` : GAMES_HOME_PATH;
}
